const view_data = {
    subscribers:{},
    charts: [],
    measurements: [],
    period: 12*60,
    refreshOptions: {time: 10, active:true},
    progressBarOptions: {options: {time: 10, position: 'top'}, show:true},
    getChart(chart_name){
        return this.charts.filter(x=>x.chart_old_name == chart_name)[0]
    },
    getChartByName(chart_name){
        return this.charts.filter(x=>x.chart_name == chart_name)[0]
    },
    getChartProp(chart_name, prop){
        return this.getChart(chart_name)[prop]
    },
    getChartNestedProp(chart_name, prop_path){
        return _.get(this.getChart(chart_name), prop_path, undefined)
    },
    setChartPropByName(chart_name, prop, value){
        let chart = this.getChartByName(chart_name)
        let old_value = chart[prop]
        chart[prop] = value
        this.publish('chart-prop-updated', {chart: chart, prop: prop, value: value, old_value: old_value})
    },
    setChartProp(chart_name, prop, value){
        let chart = this.getChart(chart_name)
        let old_value = chart[prop]
        chart[prop] = value
        this.publish('chart-prop-updated', {chart: chart, prop: prop, value: value, old_value: old_value})
    },
    setChartNestedProp(chart_name, prop_path, value){
        _.set(this.getChart(chart_name), prop_path, value)
        this.publish('chart_nested_prop_update', {chart_name:chart_name, prop_path:prop_path, value:value})
    },
    getCharts(){
        return this.charts
    },
    addChart(chart_name, props = {}){
        chart_name =  chart_name || `chart #${this.charts.length+1}`
        this.charts.push({chart_name: chart_name, chart_old_name: `chart_name_${(Math.random() + 1).toString(36).substring(2)}`, ...props})
        this.publish('added_chart', chart_name)
    },
    setCharts(charts){
        this.charts = charts
        this.publish('set_chart_list', charts)
    },
    removeChart(chart_name){
        let index = this.charts.findIndex(chart=> chart.chart_old_name == chart_name)
        
        if(index >= 0){
            this.charts.splice(index, 1)
        }
        
        this.publish('chart_destroyed', chart_name)
    },
    removeChartNestedProp(chart_name, prop_path, prop){
        let props = this.getChartNestedProp(chart_name, prop_path)
        delete props[prop]
    },
    updateChartNestedPropName(chart_name, prop_path, prop, new_prop){
        let props = this.getChartNestedProp(chart_name, prop_path)
        props[new_prop] = props[prop]
        delete props[prop]
    },
    getPeriod(){
        return this.period
    },
    setPeriod(value){
        this.period = value
        this.publish('period-change', this.period)
    },
    getMeasurements(){
        return this.period
    },
    getRefreshOptionsProp(prop){
        return this.refreshOptions[prop]
    },
    setRefreshOptionsProp(prop, value){
        this.refreshOptions[prop] = value
        this.publish('refresh-change', {prop: prop, value: this.period})
    },
    setMeasurements(measurements){
        this.measurements = measurements
        this.publish('measurements-change', this.period)
    },
    setProgresBarOptions(values){
        this.progressBarOptions = values
    },
    getProgressBarOptions(){
        return this.progressBarOptions
    },
    getProgressBarOptionsProp(prop){
        return this.progressBarOptions[prop]
    },
    getProgressBarOptionsNestedProp(prop_path){
        return _.get(this.getProgressBarOptions(), prop_path)
    },
    setProgressBarOptionsProp(prop, value){
        this.progressBarOptions[prop] = value
        this.publish('progress-bar-change', this.period)
    },
    setProgressBarOptionsNestedProp(prop_path, value){
        _.set(this.getProgressBarOptions(), prop_path, value)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default view_data